module.exports = __webpack_public_path__ + "img/135x90-02.be833363.png";